import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { createSliders, getSliders, updateSliders } from '../../actions';
import styles from './SliderItems.module.scss';
import classNames from 'classnames';
import SliderItem from './components/SliderItem/SliderItem';
import FormData from './components/FormData/FormData';
import { Button, message } from 'antd';
import { AiOutlinePlus } from 'react-icons/ai';
import i18n from '../../../../lib/i18n';
import isPayment from '../../../../lib/isPayment';
import EmptyState from '../../../../components/EmptyState/EmptyState';
import CreateAction from '../../../../components/CreateAction/CreateAction';

function SliderItems() {
  const [messageApi, contextHolder] = message.useMessage();
  const checkSubcategories = useSelector(state => state.slider.checkSubcategories);
  const checkCategories = useSelector(state => state.slider.checkCategories);
  const selectFolderId = useSelector(state => state.slider.selectFolder);
  const selectSubfolderId = useSelector(state => state.slider.selectSubfolder);
  const freeLimit = useSelector(state => state.auth.free_limit);
  const list = useSelector(state => state.slider.list);
  const item = useSelector(state => state.slider.item);
  const dispatch = useDispatch();

  const stats = useSelector((state) => state.auth.stats);
  const profile = useSelector((state) => state.auth.profile);

  useEffect(() => {
    dispatch(getSliders({
      categories: checkCategories.join(','),
      subcategories: checkSubcategories.join(','),
    }))
  }, [checkSubcategories, checkCategories])

  const handleCreate = () => {
    if (stats.sliders >= freeLimit.sliders && !isPayment(profile)) {
      window.openLimitModal();
      return;
    }
    dispatch({ type: 'SET_SLIDERS_KEY', key: 'isShowModal', data: true })
    dispatch({
      type: 'SET_SLIDERS_KEY', key: 'item', data: {
        folder_id: selectFolderId || selectSubfolderId
      }
    })
  }

  const onSave = async (values) => {
    try {
      dispatch({ type: 'SET_SLIDERS_KEY', key: 'isShowModal', data: false })
      if (values.id) {
        await dispatch(updateSliders(values))

        messageApi.open({
          type: 'success',
          content: i18n('pr_msg_updated'),
        });
      } else {
        await dispatch(createSliders(values))
        messageApi.open({
          type: 'success',
          content: i18n('pr_msg_created'),
        });
      }
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: i18n('ps_error_message'),
      });
    }
  }

  return (
    <div className={classNames('row', styles.SliderItems)}>
      {contextHolder}
      <FormData initialValues={item} onSave={onSave} />
      <div className='col-md-12'>
        <div className='row'>
          <div className='col-md-12'>
            {list.length > 0 && (
              <CreateAction className={styles.actions} label={i18n('sl_bt_create')} onClick={handleCreate} />
            )}
          </div>
        </div>
        <div className='row'>
          {list.map(_i => <SliderItem key={_i.id} slider={_i} />)}
          {list.length == 0 && <div className='col-md-12'>
            <EmptyState
              variant="slides"
              title={i18n('sl_empty_title')}
              description={i18n('sl_empty_description')}
              action={<Button type="primary" icon={<AiOutlinePlus />} onClick={handleCreate}>{i18n('sl_bt_create')}</Button>}
            />
          </div>}
        </div>
      </div>
    </div>
  )
}

export default SliderItems